__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "@amzn/awsscm-smart";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@amzn/awsscm-argo-core", "1.2.0", () => (Promise.all([__webpack_require__.e(8610), __webpack_require__.e(1827), __webpack_require__.e(3486), __webpack_require__.e(2181), __webpack_require__.e(4914), __webpack_require__.e(6672), __webpack_require__.e(6236), __webpack_require__.e(5194)]).then(() => (() => (__webpack_require__(32181))))));
			register("@apollo/client", "3.14.0", () => (Promise.all([__webpack_require__.e(8610), __webpack_require__.e(5008), __webpack_require__.e(8836), __webpack_require__.e(4914), __webpack_require__.e(9379)]).then(() => (() => (__webpack_require__(88836))))));
			register("@apollo/client", "3.8.7", () => (Promise.all([__webpack_require__.e(8610), __webpack_require__.e(1827), __webpack_require__.e(8653), __webpack_require__.e(4914)]).then(() => (() => (__webpack_require__(18653))))));
			register("react-dom", "18.3.1", () => (Promise.all([__webpack_require__.e(7950), __webpack_require__.e(4914)]).then(() => (() => (__webpack_require__(97950))))));
			register("react-router-dom", "6.30.3", () => (Promise.all([__webpack_require__.e(3216), __webpack_require__.e(5475), __webpack_require__.e(4914), __webpack_require__.e(6672)]).then(() => (() => (__webpack_require__(35475))))));
			register("react", "18.3.1", () => (__webpack_require__.e(5043).then(() => (() => (__webpack_require__(65043))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};